import LoadingDots from 'components/Common/Loaders/LoadingDots';
import { FC } from 'react';

const SplashScreen: FC = () => {
    return (
        <div className="splash-screen">
            <LoadingDots />
        </div>
    );
};

export default SplashScreen;
